<p-iconfield class="w-full">
  <input
    fluid
    (focus)="searchResults().length > 0 ? searchOpen.set(true) : null"
    type="text"
    pInputText
    [(ngModel)]="searchControl"
    (keydown.enter)="search()"
    (keydown.escape)="clearSearch()"
    [placeholder]="placeholderLabel()"
  />
  <p-inputicon>
    @if (!searching()) {
      <fa-icon [icon]="['fal', 'magnifying-glass']" size="sm" class="text-p-muted-color" />
    }
    @if (searching()) {
      <fa-icon
        animation="spin"
        animation="spin"
        [icon]="['fal', 'spinner-third']"
        size="sm"
        class="text-p-muted-color"
      />
    }
  </p-inputicon>
</p-iconfield>
<p-overlay
  appendTo="body"
  [(visible)]="searchOpen"
  contentStyleClass="bg-p-content-background max-h-72 shadow-md rounded-md border-p-content-border border p-2 gap-1 flex flex-col overflow-y-auto"
>
  @for (item of searchResults(); track $index) {
    <div
      class="flex justify-between items-center space-x-4 hover:bg-p-background-focus-color hover:cursor-pointer p-2"
      (click)="onOptionSelected(+item.id)"
    >
      <span>{{ item.attributes.web_no }}</span>

      <p-tag
        class="text-xs!"
        [value]="item.attributes.store_id | storeNameById | middleEllipsis"
        severity="secondary"
      />
    </div>
  } @empty {
    @if (searchNoResults()) {
      <div class="text-center text-p-muted-color text-sm rounded-">{{ noResultsFoundLabel() }}</div>
    }
  }
</p-overlay>
